var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"landing",attrs:{"fluid":""}},[_c('section-terms',{attrs:{"content":_vm.SectionTerms}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }